module.exports = __webpack_public_path__ + "static/media/chopraHeader.7d73e58d.png";